"use client";

import { useDynamicContext } from "@dynamic-labs/sdk-react-core";

export const useHandleLogIn = () => {
  const { handleLogOut, setShowAuthFlow } = useDynamicContext();

  const handleLogIn = async () => {
    try {
      await handleLogOut();
    } finally {
      setShowAuthFlow(true);
    }
  };

  return { handleLogIn };
};
